import { SELECIONAR_VEICULO } from '../../actions/types'

const initialState = undefined

const estadoInicial = {
  descricao: null,
  mapaVeiculoDto: null,
  idVeiculo: null,
  idRastreamento: null,
  base64Veiculo: null,
  urlImagem: null 
};

export default function reducerSelecionarVeiculo(state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_VEICULO: {
      if (action.payload) {
        return action.payload;
      }

      return estadoInicial;
    }

    default: {
      return state
    }
  }
}
